<template>
  <QuadroPrincipal
    v-if="stSelecionado && stSelecionado.id_imposto == 100"
    class="st-container"
    :classe="classe"
    :titulo="'ST'"
  >
    <Registro paddingSemCheckBox>
      <div :key="getRenderKey">
        <Cabecalho
          paddingBottom
          :titulo="stSelecionado ? stSelecionado.label : dadosResultado[0].label"
        />
        <Inaplicabilidade
          :texto="
            stSelecionado
              ? stSelecionado.texto_inaplicabilidade
              : dadosResultado[0].texto_inaplicabilidade
          "
        />
      </div>
    </Registro>
  </QuadroPrincipal>
  <QuadroPrincipal v-else-if="!selecionouSt" class="st-container" :classe="classe" :titulo="'ST'">
    <div
      class="st-content espacamento-st"
      v-for="(st, index) in dadosResultado"
      :key="`st${index}`"
    >
      <RadioButton
        v-if="dadosResultado.length > 1"
        :classe="dados.classe"
        :seleciona="seleciona"
        :imposto="st"
        :loading="loading"
      />
      <Registro>
        <div class="bloco-st">
          <label v-html="texto(st)"></label>
          <Descricao v-if="st.mensagem" :descricao="st.mensagem" />
          <Descricao :descricao="st.texto_regime" />

          <QuadroZebra :dados="st" />
        </div>
        <Notificacao v-if="!!st.alerta && !dados.base" :tipo="'alerta'" :texto="st.alerta" />

        <BaseLegal :base_legal="st.base_legal" :classe="classe" />
      </Registro>
    </div>
  </QuadroPrincipal>
  <QuadroPrincipal v-else class="st-container" :classe="classe" :titulo="'ST'">
    <div class="st-content">
      <EditButton
        v-if="dadosResultado.length > 1"
        :classe="dados.classe"
        :edita="handleEdita"
        :loading="loading"
      />
      <Registro :key="getRenderKey" :paddingSemCheckBox="dadosResultado.length == 1">
        <div class="bloco-st">
          <label v-html="texto(stSelecionado)"></label>
          <Descricao v-if="stSelecionado.mensagem" :descricao="stSelecionado.mensagem" />
          <Descricao :descricao="stSelecionado.texto_regime" />

          <QuadroZebra :dados="stSelecionado" />
        </div>
        <Notificacao
          v-if="!!stSelecionado.alerta && !dados.base"
          :tipo="'alerta'"
          :texto="stSelecionado.alerta"
        />
        <Registro v-if="!!dados.base && !!dados.base.length">
          <RegistrosMva
            :classe="classe"
            :dados="mvaFiltrado"
            :mvaSelecionado="mvaSelecionado"
            :selecionouMva="selecionouMva"
            :seleciona="selecionaMva"
            :edita="editaMva"
          />

          <Notificacao
            v-if="!!stSelecionado.alerta && selecionouMva"
            :paddingComCheckBox="dados.base.length > 1"
            :tipo="'alerta'"
            :texto="stSelecionado.alerta"
          />

          <Notificacao
            v-if="selecionouMva && mvaSelecionado.alerta"
            :tipo="'alerta'"
            :texto="mvaSelecionado.alerta"
          />
          <GrupoNotificacao v-if="selecionouMva" :registro="mvaSelecionado" />
        </Registro>

        <BaseLegal :base_legal="stSelecionado.base_legal" :classe="classe" />
      </Registro>
    </div>
  </QuadroPrincipal>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "../Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import Inaplicabilidade from "@/components/Inaplicabilidade/Inaplicabilidade.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
import QuadroZebra from "@/components/QuadroZebra/QuadroZebra.vue";
import Registro from "@/components/Registro/Registro.vue";
import RegistrosMva from "@/components/RegistrosMva/RegistrosMva";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";

import stringFormatMixin from "@/mixins/stringFormatMixin";
import RadioButton from "../Button/RadioButton.vue";
import EditButton from "@/components/Button/EditButton.vue";

import { mapGetters } from "vuex";

export default {
  name: "ResultadoSt",

  mixins: [stringFormatMixin],

  props: {
    dados: Object | Array,
    stSelecionado: Object | Array,
    mvaSelecionado: Object | Array,
    selecionouSt: Boolean,
    selecionouMva: Boolean,
    loading: Boolean,
    seleciona: Function,
    selecionaMva: Function,
    edita: Function,
    editaMva: Function
  },

  components: {
    BaseLegal,
    Cabecalho,
    Descricao,
    Inaplicabilidade,
    QuadroPrincipal,
    QuadroZebra,
    Registro,
    RegistrosMva,
    Notificacao,
    RadioButton,
    EditButton,
    GrupoNotificacao
  },

  data() {
    return {
      classe: "icms_st"
    };
  },

  created() {
    if (this.dadosResultado.length == 1) {
      this.seleciona(this.dadosResultado[0]);
    }
  },

  updated() {
    if (!this.selecionouSt && this.dadosResultado.length == 1) {
      this.seleciona(this.dadosResultado[0]);
    }
  },

  computed: {
    ...mapGetters("reRender", ["getRenderKey"]),
    // dadosResultado() {
    //  return this.dados.dados[0]
    // },
    mvaFiltrado() {
      if (this.selecionouSt) {
        let mvaRegra = this.stSelecionado.id_regra;
        return this.dados.base.filter(regra => regra.id_regra == mvaRegra);
      }
      return [];
    },

    dadosResultado() {
      return this.dados.dados;
    }
  },

  methods: {
    texto(st) {
      const texto =
        st.label.indexOf("NÃO") > -1
          ? this.strReplace(st.label, "NÃO", "<b>NÃO</b>")
          : this.strReplace(st.label, "Substituto Tributário", "<b>Substituto Tributário</b>");
      const textoSubstituido = this.strReplace(
        texto,
        "Substituído Tributário",
        "<b>Substituído Tributário</b>"
      );

      return textoSubstituido;
    },
    handleEdita() {
      this.edita();
    }
  }
};
</script>

<style lang="scss" scoped>
// .st-container {
//   padding-left: 2.5rem;

// }

.separador {
  margin-top: 1rem;
}

.registro-content {
  margin-bottom: 7px;

  label {
    margin-bottom: 0.5rem;
    font-size: 1rem;
  }
  &:last-child {
    margin-bottom: 0;
  }
}
.st-content {
  display: flex;
}
.bloco-st {
  margin-bottom: 1rem;
}
.espacamento-st {
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}
@media only print {
  .st-container {
    page-break-inside: avoid;
  }
}
</style>
